import * as types from '../types';
import { ISearchApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class SearchHttpApi extends HttpApi implements ISearchApi {
  async globalSearch(query: string, options: types.GlobalSearchOptions = {}): Promise<types.GlobalSearchResponse> {
    const params: Record<string, string | number> = { q: query };
    if (options.limit !== undefined) params.limit = options.limit;
    if (options.types && options.types.length > 0) params.types = options.types.join(',');
    return (await this.http.get<types.APIResponse<types.GlobalSearchResponse>>('/search', { params })).data.data;
  }
}
